import { useQueryClient } from '@tanstack/react-query';
import type { NotificationType } from '@ruta/shared';
import { queryKeys } from '@/lib/queryKeys';
import { useUserProfile } from './useQueries';
import { useUpdateNotificationPreferencesMutation } from './useMutations';
import type { UserProfileResponse } from '@/lib/api/routes/users';

export function useHiddenInAppNotificationTypes() {
  const { data } = useUserProfile();
  return data?.notificationPreferences?.hiddenInAppTypes ?? [];
}

export function useSetHiddenInAppNotificationTypes() {
  const queryClient = useQueryClient();
  const mutation = useUpdateNotificationPreferencesMutation();

  return (next: NotificationType[]) => {
    const previous = queryClient.getQueryData<UserProfileResponse>(queryKeys.users.profile());
    queryClient.setQueryData<UserProfileResponse>(queryKeys.users.profile(), (old) => {
      if (!old) return old;
      return {
        ...old,
        notificationPreferences: {
          ...old.notificationPreferences,
          hiddenInAppTypes: next,
        },
      };
    });
    mutation.mutate(
      { hiddenInAppTypes: next },
      {
        onError: () => {
          if (previous) queryClient.setQueryData(queryKeys.users.profile(), previous);
        },
      },
    );
  };
}
